export default __webpack_public_path__ + "static/media/settings.87c2e582.svg";